import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import portraitImage from "@/assets/portrait.webp";
export function Introduction() {
  return <section className="section-padding border-t border-border">
      <div className="container-wide">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          <div>
            <p className="text-small uppercase tracking-widest mb-4">Over mij</p>
            <h2 className="text-balance">
              Één persoon voor al je online zaken
            </h2>
            <p className="text-lead mt-6 mb-6">
              Ik ben de Online Sale Specialist. Ik help ZZP'ers en bedrijven met hun 
              complete online aanwezigheid. Van domeinnaam en hosting tot website, 
              webshop en doorlopende optimalisatie.
            </p>
            <p className="text-muted-foreground mb-8 text-xl">
              Geen gedoe met verschillende partijen. Geen technisch jargon. 
              Gewoon één persoon die begrijpt wat je nodig hebt en het voor je regelt.
            </p>
            <Link to="/over-mij" className="inline-flex items-center text-accent font-medium hover:text-accent/80 transition-colors group">
              Meer over mijn aanpak
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
          
          <div className="relative">
            <div className="aspect-[4/5] rounded-lg overflow-hidden">
              <img 
                src={portraitImage} 
                alt="Online Sale Specialist - Persoonlijke foto" 
                className="w-full h-full object-cover object-top"
                width={544}
                height={680}
                sizes="(max-width: 1024px) 90vw, 544px"
                loading="lazy"
                decoding="async"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -left-6 w-32 h-32 border border-border rounded-lg -z-10" />
          </div>
        </div>
      </div>
    </section>;
}